import Service from "@/helpers/py-service";
const state = {
  loading: false,
  meta: {},
  list: [],
  aggregattedData: {},
};

const mutations = {
  SET_META(state, data) {
    if (data.meta) {
      state.meta.page = data.meta.current_page;
      state.meta.itemsPerPage = data.meta.per_page;
      state.meta.lastPage = data.meta.last_page;
      state.meta.totalItems = data.meta.total;
    }
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_AGGREGATED_DATA(state, payload) {
    state.aggregattedData = payload;
  }
};

const actions = {
  list: (store, params) => {
    store.state.loading = true;
    return Service.get("dashboard-management/arrival/vehicle-listing", params)
      .then((data) => {
        store.commit("SET_META", data?.body);
        store.commit("SET_LIST", data?.body?.data);
      })
      .finally(() => {
        store.state.loading = false;
      });
  },
  aggregattedData: (store, params) => {
    store.state.loading = true;
    return Service.get("dashboard-management/arrival/first-section", params)
      .then((data) => {
        store.commit("SET_AGGREGATED_DATA", data?.body?.data);
      })
      .finally(() => {
        store.state.loading = false;
      });
  },
};

const getters = {
  getLoading(state) {
    return state.loading;
  },
  getList(state) {
    return state.list;
  },
  getMeta(state) {
    return state.meta;
  },
  getAggregattedData(state) {
    return state.aggregattedData;
  },
};

const arrivalDashboard = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default arrivalDashboard;
